import React from 'react';
// import './lo'
interface ImageSelectorProps {
  // eslint-disable-next-line react/boolean-prop-naming
  show: boolean;
}

const LoaderOverlay: React.FC<ImageSelectorProps> = ({show}) => {
  if (!show) return null;

  return (
    <div className="loader-overlay">
      <div className="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  );
};

export default LoaderOverlay;
